import './style/index.less';
import AccountPageLayout from './AccountPageLayout';

export default AccountPageLayout;
